var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"app-icon-btn",class:{ 'app-icon-btn--danger': _vm.danger },attrs:{"type":"button","disabled":_vm.disabled,"title":_vm.title,"aria-label":_vm.title}},'button',_vm.$attrs,false),_vm.$listeners),[_c('AppIcon',{attrs:{"icon":_vm.icon,"size":_vm.size,"color":_vm.iconColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }